import { Outlet } from "react-router-dom";
import useAuth from "./useAuth";

const RequireAuth = ({ allowedRoles }) => {
    const { auth }: any = useAuth();
    return (
        allowedRoles?.find((role: any) => auth?.role?.includes(role)) && (
            <Outlet />
        )
    )
}

export default RequireAuth;